import type { BatchPreviewModelKey } from "../batch-preview.type";

import { type ReferentialStateEndpoint } from "@/entities/referential/referential-states";

export const STATE_REF_CONFIG: Record<
  BatchPreviewModelKey,
  ReferentialStateEndpoint
> = {
  intervention: "states.interventions",
  observation: "states.observations",
};
